import React from 'react';
import * as _ from 'lodash';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { getTaskFiles, searchUserWithAttachments } from '../../../services/domain/taskService';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';
import * as drawerActions from '../../../actions/drawerActions';
import * as taskActions from '../../../actions/taskActions';
import LessonListContainer from '../LessonListContainer/index';
import * as assignmentsContentPanelService from './assignmentsContentPanelService';
import { getConfiguration, MODES } from './assignmentsContentPanelService';
import * as lessonListContainerService from '../LessonListContainer/lessonListContainerService';
import { isAfter, isPast } from '../../../utils/dateUtlis';
import DrawerCommonPanel from '../DrawerCommonPanel';
import PanelTextarea from '../CommonComponents/PanelTextarea';
import PanelChoosingCarousel from '../CommonComponents/PanelChoosingCarousel';
import DatesContainer from '../DateSelectorContainer/DatesContainer';
import { TASK_GROUP_MIN_PARTICIPANTS, TASK_TABS_CONSTANTS } from '../../../const';
import * as revealActions from '../../../actions/revealActions';
import { resolveContentTaskAssignment } from '../../../utils/AssignContentPanelUtils';
import { TASK_TYPE } from '../../../types/task';
import CircularProgress from '@material-ui/core/CircularProgress';
import AssignmentsContentPanelSwitch from './AssignmentsContentPanelSwitch';
import UploadFileContainer from '../TaskPanel/UploadFileContainer';
import { findSpecialCharacters, removeDiacritics } from '../../../utils/stringUtils';
import * as assetService from '../../../services/assets/assetsService';
import * as messageAlert from '../../../actions/messageAlertAction';
import SelectTaskTypePanel from '../SelectTaskTypePanel';

export class AssignmentsContentPanel extends React.Component {
  static propTypes = {
    fetchingBooksActivities: PropTypes.bool,
    locale: PropTypes.string,
    configuration: PropTypes.object,
    taskActions: PropTypes.object,
    mode: PropTypes.string.isRequired,
    selectedClassroom: PropTypes.any,
    drawerActions: PropTypes.any,
    revealActions: PropTypes.any,
    task: PropTypes.object.isRequired,
    assignmentsDrawerActions: PropTypes.any,
    openChooseMultiple: PropTypes.any,
    lessons: PropTypes.object,
    isAllChecked: PropTypes.bool,
    updateAllActivitiesChecks: PropTypes.func,
    setLessons: PropTypes.func,
    setAllChecked: PropTypes.func,
    groups: PropTypes.array,
    activeTaskTab: PropTypes.string,
    setDatesContainerInteraction: PropTypes.func,
    datesContainerState: PropTypes.object,
    contentsNotFound: PropTypes.bool,
    filteredUsers: PropTypes.object,
    isAppOnline: PropTypes.bool,
    selectedTask: PropTypes.object,
    isAboutContent: PropTypes.bool,
    customerId: PropTypes.number
  };

  static defaultProps = {
    datesContainerState: { currentDate: dayjs(), hasInteraction: false }
  };

  constructor(props) {
    super(props);
    let deadLine =
      props.task && props.task.selectedDeadLine ? Object.assign({}, props.task.selectedDeadLine) : undefined;
    let allowFile = !_.isUndefined(props.task.allowFile) ? props.task.allowFile : false;
    let allowUserComment = !_.isUndefined(props.task.allowUserCommentResponse)
      ? props.task.allowUserCommentResponse
      : false;
    let allowExpiredResponse = !_.isUndefined(props.task.allowExpiredResponse)
      ? props.task.allowExpiredResponse
      : false;
    let modeCurrent = MODES.CREATE;
    this.state = {
      description: props.task.description,
      deadLine,
      allowFile,
      allowUserComment,
      allowExpiredResponse,
      modeCurrent,
      sendingForm: false,
      showButtons: false,
      files: [],
      activeLoader: true,
      taskType:
        props.mode === MODES.EDIT || (props.task?.selectedGroup?.id && props.task.selectedGroup?.id.length > 0)
          ? TASK_TYPE.INDIVIDUAL
          : null,
      isPanelChoosingCarouselActive: true,
      nRandomGroups: 0,
      randomGroups: []
    };
  }

  componentDidMount() {
    const { task, mode, customerId } = this.props;
    let currentMode = isPast(task.dueDate) && mode === MODES.EDIT ? MODES.READ : mode;
    this.setCurrentMode(currentMode);

    if (task.students.length <= TASK_GROUP_MIN_PARTICIPANTS) {
      this.setState({
        taskType: TASK_TYPE.INDIVIDUAL,
        isPanelChoosingCarouselActive: true,
        randomGroups: null
      });
    }

    getTaskFiles(task, customerId)
      .then(fetchedFiles => {
        this.setState({
          files: fetchedFiles,
          activeLoader: false
        });
      })
      .catch(() => {
        this.setState({
          activeLoader: false
        });
      });
  }

  changeTaskType = taskType => {
    if (taskType === TASK_TYPE.GROUP) {
      this.setState({
        taskType: TASK_TYPE.GROUP,
        isPanelChoosingCarouselActive: false,
        randomGroups: null
      });
    } else {
      this.setState({
        taskType: TASK_TYPE.INDIVIDUAL,
        isPanelChoosingCarouselActive: true,
        randomGroups: null
      });
    }
  };

  changeRandomGroups = randomGroups => {
    this.setState({ randomGroups });
  };

  changeAllowFile = allowFile => {
    this.setState({ allowFile });
  };

  changeAllowUserComment = allowUserComment => {
    this.props.assignmentsDrawerActions.setAllowUserCommentResponse(allowUserComment);
    this.setState({ allowUserComment });
  };

  changeAllowedExpiredResponse = allowExpiredResponse => {
    this.setState({ allowExpiredResponse });
  };

  setCurrentMode = modeCurrent => {
    this.setState({ modeCurrent });
  };

  componentDidUpdate(prevProps, prevState, prevContext) {
    const { lessons, task, assignmentsDrawerActions, mode } = this.props;

    if (Object.keys(prevProps.lessons).length !== Object.keys(lessons).length) {
      //   let activities = lessonListContainerService.getAllActivitiesFromLessonsActivities(task.activities);
      assignmentsDrawerActions.onCheckedActivitiesChange(lessonListContainerService.getActivitiesChecked(lessons));
    }
    if (prevProps.task.students.length !== task.students.length && mode === MODES.CREATE) {
      if (task.students.length <= TASK_GROUP_MIN_PARTICIPANTS) {
        this.setState({ taskType: TASK_TYPE.INDIVIDUAL, isPanelChoosingCarouselActive: true, randomGroups: null });
      } else if (this.state.taskType === TASK_TYPE.INDIVIDUAL) {
        this.setState({ taskType: null });
      }
    }
  }

  createAssignment = async () => {
    const {
      task,
      assignmentsDrawerActions,
      taskActions,
      revealActions,
      selectedClassroom,
      isAppOnline,
      lessons,
      isAboutContent,
      customerId
    } = this.props;
    const { allowFile, allowUserComment, allowExpiredResponse, files } = this.state;
    const lessonsChecked = {};
    task.checkedActivities.map(chk => {
      lessonsChecked[chk] = lessons[chk];
      if (typeof lessons[chk] === 'undefined') {
        const lessonsOnjects = Object.values(lessons);
        lessonsOnjects.map(less => {
          const lessObj = less;
          const activitiesObject = Object.values(less.activities);
          activitiesObject.map(act => {
            if (act.activityId === chk) {
              lessonsChecked[lessObj.activityId] = lessons[lessObj.activityId];
            }
          });
        });
      }
    });
    let selectGroup = task.selectedGroup;
    let belong = [];
    let notBelong = [];
    let groupExist = true;

    if (isAboutContent) {
      ({ selectGroup, belong, notBelong, groupExist } = resolveContentTaskAssignment(
        task,
        this.props.groups,
        isAppOnline,
        lessonsChecked
      ));
    }

    const assignment = {
      wording: task.description,
      name: task.title,
      dueDate: task.dueDate,
      startDate: task.startDate,
      checkedActivities: task.checkedActivities,
      //   selectedGroup: isAboutContent ? { id: 0, users: belong, isGroup: false, isEveryone: false } : selectGroup,
      //   selectedGroup: selectGroup,
      classroom: selectedClassroom,
      book: task.book,
      allowFile: allowFile,
      allowUserComment: allowUserComment,
      allowExpiredResponse,
      taskType: this.state.taskType,
      isAboutContent
    };

    if (this.state.taskType === TASK_TYPE.GROUP) {
      const transformedGroups = {};
      for (let groupKey in this.state.randomGroups) {
        transformedGroups[groupKey] = this.state.randomGroups[groupKey].map(student => student._id);
      }
      assignment.students = transformedGroups;
    } else {
      assignment.selectedGroup = isAboutContent
        ? { id: 0, users: belong, isGroup: false, isEveryone: false }
        : selectGroup;
    }

    if (files && files.length) {
      const uploadedFiles = await this.uploadFiles(files);
      assignment.files = uploadedFiles.map(fileData => fileData.uuid);
    }

    if (!groupExist) {
      revealActions.openTaskWithoutStudentsOfThisGroup(true);
    } else if (notBelong.length) {
      revealActions.openStudentsWithoutAssignmentInLessons(true, notBelong, {
        assignment,
        selectedClassroomId: selectedClassroom.id
      });
    } else {
      assignmentsDrawerActions.createAssignment(assignment, selectedClassroom.id).then(() => {
        taskActions.getAllTasks(selectedClassroom.id);
      });
    }
  };

  editAssignment = async () => {
    const { task, assignmentsDrawerActions, selectedClassroom } = this.props;
    const { allowFile, allowExpiredResponse, files } = this.state;
    const assignment = {
      wording: task.description,
      dueDate: task.dueDate,
      startDate: task.startDate,
      checkedActivities: task.checkedActivities,
      title: task.title,
      allowFile: task.allowFile ? task.allowFile : allowFile,
      allowUserComment: task.allowUserCommentResponse,
      allowExpiredResponse: allowExpiredResponse
    };

    if (this.state.files && this.state.files.length) {
      const filesToUpload = this.state.files.filter(file => !task.files.includes(file.uuid));
      const uploadedFiles = await this.uploadFiles(filesToUpload);
      assignment.files = [
        ...files.filter(file => task.files.includes(file.uuid)).map(file => file.uuid),
        ...uploadedFiles.map(fileData => fileData.uuid)
      ];
    }

    assignmentsDrawerActions.editAssignment(assignment, selectedClassroom.id, task.id);
  };

  onAssignButtonClick = () => {
    const { mode } = this.props;
    this.setState({ sendingForm: true, activeLoader: true });
    if (mode === MODES.CREATE) {
      this.createAssignment();
    } else if (mode === MODES.EDIT) {
      this.setState({ sendingForm: true });
      this.editAssignment();
    }
  };

  renderAssignmentsList = () => {
    const {
      task,
      lessons,
      isAllChecked,
      updateAllActivitiesChecks,
      setLessons,
      setAllChecked,
      contentsNotFound
    } = this.props;
    const { modeCurrent } = this.state;
    if (contentsNotFound) {
      return <div className="activity-content-not-found">{I18n.t('panels.assignment.contentTaskNotFound')}</div>;
    }
    if (_.isEmpty(task.activities) || _.isNil(task.activities)) {
      return <div />;
    }

    return (
      <div>
        <span className="section-title-label" style={{ marginLeft: '40px' }}>
          {I18n.t('panels.assignment.choose')}
        </span>
        <LessonListContainer
          task={task}
          units={task.book && task.book.content ? task.book.content : null} // true: normal task | false: content task
          editable={getConfiguration(modeCurrent).activities}
          setAllChecked={setAllChecked}
          lessons={lessons}
          isAllChecked={isAllChecked}
          activities={task.activities}
          setLessons={setLessons}
          updateAllActivitiesChecks={updateAllActivitiesChecks}
          checkedActivities={_.map(task.checkedActivities, act => act.activityId)}
          setShowButtons={this.setShowButtons}
        />
      </div>
    );
  };

  setSelectedGroup = group => {
    const { assignmentsDrawerActions, mode } = this.props;
    if (getConfiguration(mode).groups) {
      let selectedGroup = assignmentsContentPanelService.getGroupWithId(group);
      assignmentsDrawerActions.setSelectedGroup(selectedGroup);
    }
    this.setShowButtons(true);
  };

  onInputTitle = event => {
    this.props.assignmentsDrawerActions.setTitleTask(event.target.value);
    this.setShowButtons(true);
  };

  onInputDescription = event => {
    this.props.assignmentsDrawerActions.setDescriptionTask(event.target.value);
    this.setShowButtons(true);
  };

  showAllowFileModal = () => {
    this.props.revealActions.openDisableEvaluationsReveal(true, this.props.task);
  };

  showAllowCommentModal = () => {
    this.props.revealActions.openDisableCommentReveal(true, this.props.task);
  };

  setShowButtons = show => {
    this.setState({ showButtons: show });
  };

  onChangeAllowFile = () => {
    const { task, selectedTask } = this.props;
    const { allowFile, modeCurrent } = this.state;
    const taskAllowFile = _.isNil(task.allowFile) ? false : task.allowFile;

    if (!getConfiguration(modeCurrent).allowFile || (taskAllowFile && modeCurrent === MODES.EDIT)) {
      const numberAttachmentUsers = searchUserWithAttachments(selectedTask).length;
      if (numberAttachmentUsers === 0) {
        this.props.assignmentsDrawerActions.setAllowFile(false);
      } else {
        this.showAllowFileModal();
      }
    } else {
      this.changeAllowFile(!allowFile);
    }
    this.setShowButtons(true);
  };

  onChangeAllowUserComment = () => {
    const { modeCurrent } = this.state;
    const { task, selectedTask } = this.props;

    if (task.allowUserCommentResponse && modeCurrent === MODES.EDIT) {
      var showAlert = false;
      Object.keys(selectedTask.studentAttempts).forEach((currentValue, index, array) => {
        let responses = selectedTask.studentAttempts[currentValue].responses;
        if (responses.length > 0) {
          responses.forEach((value, index, array) => {
            let comment = value.data.commentMessageText;
            if (comment !== '') {
              showAlert = true;
            }
          });
        }
      });
      if (showAlert) {
        this.showAllowCommentModal();
        this.setShowButtons(true);
      } else {
        this.changeAllowUserComment(!task.allowUserCommentResponse);
        this.setShowButtons(true);
      }
    } else {
      this.changeAllowUserComment(!task.allowUserCommentResponse);
      this.setShowButtons(true);
    }
  };

  onChangeAllowExpiredResponse = () => {
    const { allowExpiredResponse } = this.state;
    this.changeAllowedExpiredResponse(!allowExpiredResponse);
    this.setShowButtons(true);
  };

  selectDeadLine = date => {
    const { assignmentsDrawerActions } = this.props;
    assignmentsDrawerActions.setDueDate(date);
    this.setShowButtons(true);
  };

  selectStartDate = date => {
    const { assignmentsDrawerActions } = this.props;
    assignmentsDrawerActions.setStartDate(date);
    this.setShowButtons(true);
  };

  uploadFiles = async files => {
    const { customerId, selectedClassroom } = this.props;
    return Promise.all(
      files.map(async file => {
        const assetMetaData = {
          fileName: removeDiacritics(file.name || file.fileName),
          customerId,
          assetType: 'TASK',
          classroomId: selectedClassroom.id
        };

        return assetService.uploadAsset(file, assetMetaData);
      })
    );
  };

  renderSwitch = () => {
    const { task } = this.props;
    const { allowFile } = this.state;
    const taskAllowFile = _.isNil(task.allowFile) ? false : task.allowFile;
    return (
      <AssignmentsContentPanelSwitch
        checked={taskAllowFile ? taskAllowFile : allowFile}
        onChange={() => this.onChangeAllowFile(!allowFile)}
        text={I18n.t('panels.assignment.uploadOneFile')}
        cssClass={'attach-file attach-element'}
      />
    );
  };
  renderSwitchCommentary = () => {
    const { task } = this.props;

    return (
      <AssignmentsContentPanelSwitch
        checked={task.allowUserCommentResponse}
        onChange={() => this.onChangeAllowUserComment(!task.allowUserCommentResponse)}
        text={I18n.t('panels.assignment.allowUserComment')}
        cssClass={'attach-comment attach-element'}
      />
    );
  };
  renderSwitchExpired = () => {
    const { allowExpiredResponse } = this.state;
    const { isAboutContent } = this.props;
    const taskAllowExpiredResponse = _.isNil(allowExpiredResponse) ? false : allowExpiredResponse;
    // Solo aplicar attach-comment si hay switches anteriores (cuando !isAboutContent)
    const cssClass = isAboutContent ? 'attach-element' : 'attach-comment attach-element';
    return (
      <AssignmentsContentPanelSwitch
        checked={taskAllowExpiredResponse ? taskAllowExpiredResponse : allowExpiredResponse}
        onChange={() => this.onChangeAllowExpiredResponse(!allowExpiredResponse)}
        text={I18n.t('panels.assignment.allowExpiredResponse')}
        cssClass={cssClass}
      />
    );
  };

  onChangeFile = file => {
    if (findSpecialCharacters([file.name])) {
      this.setState(prevState => ({ files: [...prevState.files, file] }));
      if (this.props.task.description) {
        this.setShowButtons(true);
      }
    } else {
      this.props.messageAlert.error(I18n.t('upload.charactersNotAllow'));
    }
  };

  onDeleteFile = index => {
    this.setState(prevState => ({ files: prevState.files.filter((file, i) => i !== index) }));
    this.setShowButtons(true);
  };

  render() {
    const {
      checkedActivities,
      task,
      locale,
      mode,
      openChooseMultiple,
      activeTaskTab,
      drawerActions,
      lessons,
      setDatesContainerInteraction,
      datesContainerState,
      filteredUsers,
      fetchingBooksActivities,
      isAboutContent
    } = this.props;
    const { modeCurrent, sendingForm, showButtons } = this.state;
    const title = _.isNil(task.title) ? '' : task.title;
    if (!getConfiguration(mode).saveButton || modeCurrent === 'read') return;

    let emptyFields =
      (_.isEmpty(checkedActivities) && !_.isEmpty(task.activities)) ||
      _.isEmpty(task.description) ||
      _.isEmpty(task.title);
    const invalidStartDateOnCreate =
      mode === MODES.CREATE &&
      (isAfter(task.startDate, task.dueDate, 'seconds') ||
        isAfter(datesContainerState.currentDate, task.startDate, 'seconds'));
    const invalidStartDateOnEdit =
      mode === MODES.EDIT &&
      activeTaskTab === TASK_TABS_CONSTANTS.FUTURE.key &&
      (isAfter(task.startDate, task.dueDate, 'seconds') ||
        isAfter(datesContainerState.currentDate, task.startDate, 'seconds'));
    const invalidDates = invalidStartDateOnCreate || invalidStartDateOnEdit;

    const buttonText = modeCurrent === MODES.EDIT ? 'panels.assignment.save' : 'panels.assignment.assignTask';
    const panelHeaderTitle =
      modeCurrent === MODES.EDIT ? 'panels.assignment.editAssignment' : 'panels.assignment.newAssignment';
    let hideRowButtons = false;
    hideRowButtons = !showButtons;
    hideRowButtons = modeCurrent === MODES.CREATE ? emptyFields : hideRowButtons;
    const classes = Object.keys(lessons).length ? 'fit-to-content' : '';
   
    if (!this.state.taskType && !isAboutContent) {
      return (
        <SelectTaskTypePanel
          task={this.props.task}
          onChangeTaskType={this.changeTaskType}
          changeRandomGroups={this.changeRandomGroups}
          totalStudents={task.students.length}
        />
      );
    }
    return (
      <DrawerCommonPanel
        classes={classes}
        closePanel={drawerActions.closeDrawerAndRemoveContent}
        panelHeaderTitle={I18n.t(panelHeaderTitle)}
        hideRowButtons={emptyFields || invalidDates || hideRowButtons}
        disableButtons={sendingForm}
        primaryButtonText={buttonText}
        outOfPaddingChildren={this.renderAssignmentsList()}
        onPrimaryButtonClick={this.onAssignButtonClick}
      >
        <DatesContainer
          disabledStartDate={mode === MODES.EDIT && activeTaskTab === TASK_TABS_CONSTANTS.IN_PROGRESS.key}
          setDatesContainerInteraction={setDatesContainerInteraction}
          datesContainerState={datesContainerState}
          selectDeadLine={this.selectDeadLine}
          selectStartDate={this.selectStartDate}
          deadLine={task.dueDate}
          mode={mode}
          startDate={task.startDate}
          locale={locale}
        />

        {modeCurrent === MODES.CREATE && !fetchingBooksActivities && this.state.isPanelChoosingCarouselActive ? (
          <PanelChoosingCarousel
            label={I18n.t('panels.assignment.whoAssigned')}
            groups={task.book && Object.keys(task.book).length ? filteredUsers.availableGroups : this.props.groups}
            setSelectedGroup={this.setSelectedGroup}
            mode={mode}
            selectedGroup={task.selectedGroup}
            openChooseMultiple={openChooseMultiple}
          />
        ) : (
          modeCurrent === MODES.CREATE &&
          fetchingBooksActivities && (
            <div key={'loader'} className="loader">
              <CircularProgress />
            </div>
          )
        )}

        <span className="section-title-label">{I18n.t('panels.assignment.allowStudents')}</span>
        <div style={{ marginLeft: '5em' }}>
          {!isAboutContent && (
            <>
              {this.renderSwitch()}
              {this.renderSwitchCommentary()}
            </>
          )}
          {this.renderSwitchExpired()}
        </div>
        <PanelTextarea
          className="title-input"
          label={I18n.t('panels.assignment.title')}
          placeholder={`${I18n.t('panels.assignment.addTitle')} [${I18n.t('panels.assignment.mandatory')}]`}
          onInput={this.onInputTitle}
          value={title}
        />

        <PanelTextarea
          label={I18n.t('panels.assignment.description')}
          placeholder={`${I18n.t('panels.assignment.addDescription')} [${I18n.t('panels.assignment.mandatory')}]`}
          disabled={!getConfiguration(modeCurrent).description}
          onInput={this.onInputDescription}
          value={task.description}
        />

        <span className="section-title-label">{I18n.t('common.files')}</span>
        <UploadFileContainer
          deleteResponseFile={(e, i) => this.onDeleteFile(i)}
          disableClick={false}
          defaultFile={this.state.files}
          onChangeFile={file => this.onChangeFile(file)}
          showLoader={this.state.activeLoader}
          canChange={true}
          isInstructor={true}
        />
      </DrawerCommonPanel>
    );
  }
}

function mapStateToProps(state) {
  return {
    configuration: state.account.configuration,
    locale: state.i18n.locale,
    selectedClassroom: state.classrooms.selectedClassroom.classroom,
    groups: state.classrooms.selectedClassroom.groups,
    activeTaskTab: state.task.activeTaskTab,
    contentsNotFound: state.task.contentsNotFound,
    selectedTask: state.task.selectedTask,
    fetchingBooksActivities: state.assignmentsDrawerActions.fetchingBooksActivities,
    checkedActivities: state.assignmentsDrawerActions.checkedActivities,
    customerId: state.account.configuration.customerId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch),
    revealActions: bindActionCreators(revealActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsContentPanel);
